import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

import { fetchWrapper } from "@helpers/fetchwrapper";

import CardArrow from "@areas/shared/components/cards/CardArrow";

import defaultLogo from "@content/img/shared/education/png/default-logo.png";
import defaultVuz from "@content/img/jpg/default-vuz.jpg";
import noPhoto from "@content/img/notPhoto1.jpg";

import styles from "./styles/about.module.css";

function About({ data }) {
  const [person, setPerson] = useState({
    fio: null,
    positions: [],
    emails: [],
    phones: [],
  });
  const [committee, setCommittee] = useState({
    about: null,
    description: null,
    emails: [],
    phones: [],
    groupsVK: [],
    maxChat:[]
  });

  useEffect(() => {
    if (data.Contacts.length > 0) {
      let persons = data.Contacts.filter((p) => p.IdType === 4);
      if (persons.length > 0) {
        fetchWrapper
          .get(
            `/v1/api/app/getContacts?id_parent=${persons[0].Id}&id_parent_type=4`
          )
          .then((res) => {
            setPerson({
              fio: persons[0].Value,
              emails: res.filter((p) => p.IdType === 1),
              phones: res.filter((p) => p.IdType === 2),
              positions: res.filter((p) => p.IdType === 5),
            });
          });
      }
    }
    if (data.SelectionCommittees.length > 0) {
      let committee = data.SelectionCommittees[0];
      setCommittee({
        about: committee.About,
        description: committee.Description,
        emails: committee.Contacts.filter((p) => p.IdType === 1),
        phones: committee.Contacts.filter((p) => p.IdType === 2),
        groupsVK: committee.Contacts.filter((p) => p.IdType === 6),
        maxChat: committee.Contacts.filter((p) => p.IdType === 7),
      });
    }
  }, [data]);

  const getSite = (data) => {
    if (data.Contacts.length > 0) {
      let sites = data.Contacts.filter((p) => p.IdType === 3);
      if (sites.length > 0) {
        return sites[0].Value;
      }
    }
    return "Нет сайта";
  };

  const getPhone = (data) => {
    if (data.Contacts.length > 0) {
      let phones = data.Contacts.filter((p) => p.IdType === 2);
      if (phones.length > 0) {
        return phones[0].Value;
      }
    }
    return "Нет телефона";
  };
  const getGroupVK = (data) => {
    if (data.Contacts.length > 0) {
      let group = data.Contacts.filter((p) => p.IdType === 6);
      if (group.length > 0) {
        return group[0].Value;
      }
    }
    return "Нет телефона";
  };
  const getMaxIcon=(data)=>{
    //<img src="/icons/Max_logo.svg" alt="Иконка MAX" width="32" height="32">
    if (data.Contacts.length > 0) {
      let max = committee.maxChat;
      if (max.length > 0) {
        return (<a target="_blank" href={max[0].Value}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" width="24" height="24"><defs><linearGradient id="b"><stop offset="0" stop-color="#00f"/><stop offset="1" stop-opacity="0"/></linearGradient><linearGradient id="a"><stop offset="0" stop-color="#4cf"/><stop offset=".662" stop-color="#53e"/><stop offset="1" stop-color="#93d"/></linearGradient><linearGradient id="c" x1="117.847" x2="1000" y1="760.536" y2="500" gradientUnits="userSpaceOnUse" href="#a"/><radialGradient id="d" cx="-87.392" cy="1166.116" r="500" fx="-87.392" fy="1166.116" gradientTransform="rotate(51.356 1551.478 559.3)scale(2.42703433 1)" gradientUnits="userSpaceOnUse" href="#b"/></defs><rect width="1000" height="1000" fill="url(#c)" ry="249.681"/><rect width="1000" height="1000" fill="url(#d)" ry="249.681"/><path fill="#fff" fill-rule="evenodd" d="M508.211 878.328c-75.007 0-109.864-10.95-170.453-54.75-38.325 49.275-159.686 87.783-164.979 21.9 0-49.456-10.95-91.248-23.36-136.873-14.782-56.21-31.572-118.807-31.572-209.508 0-216.626 177.754-379.597 388.357-379.597 210.785 0 375.947 171.001 375.947 381.604.707 207.346-166.595 376.118-373.94 377.224m3.103-571.585c-102.564-5.292-182.499 65.7-200.201 177.024-14.6 92.162 11.315 204.398 33.397 210.238 10.585 2.555 37.23-18.98 53.837-35.587a189.8 189.8 0 0 0 92.71 33.032c106.273 5.112 197.08-75.794 204.215-181.95 4.154-106.382-77.67-196.486-183.958-202.574Z" clip-rule="evenodd"/></svg>
</a>);
      }
    }
    return "";
  };

  const checkActiveProp = (item) => {
    switch (item.IdType) {
      case 4:
        return item.Value === "0" ? 0 : 1;
      default:
        return item.Value;
    }
  };

  return (
    <div className={styles.block}>
      <div className={`container ${styles.second}`}>
        <div className={styles.mainPhoto}>
          <img src={data.LogoLink ? data.LogoLink : defaultVuz} alt="Логотип" />
        </div>
        <div className={styles.info}>
          <div className={styles.header}>
            <img
              className={styles.logo}
              src={data.LogoLink ? data.LogoLink : defaultLogo}
              alt="Логотип"
            />
            <h1>{data.Shortname ? data.Shortname : data.Fullname}</h1>
          </div>
          <PerfectScrollbar className={styles.description}>
            {data.Description}
          </PerfectScrollbar>
          <div className={styles.addresses}>
            <div className={styles.title}>Адрес:</div>
            <div className={styles.address}>
              {data.Addresses ? data.Addresses[0].Value : null}
            </div>
          </div>
          <div className={styles.contacts}>
            <div className={styles.contact}>
              <div className={styles.title}>ИНН:</div>
              <div className={styles.description}>{data.Inn}</div>
            </div>
            <div className={styles.contact}>
              <div className={styles.title}>Сайт:</div>
              <a
                href={getSite(data) !== "Нет сайта" ? getSite(data) : null}
               target="_blank" className={`${styles.description} ${styles.link}`}
              >
                {getSite(data)}
              </a>
            </div>
            <div className={styles.contact}>
              <div className={styles.title}>Телефон:</div>
              <a href={`tel:${getPhone(data)}`} className={styles.description}>
                {getPhone(data)}
              </a>
            </div>
            <div className={styles.contact}>
              <div className={styles.title}>Группа ВК:</div>
              <a
                href={`tel:${getGroupVK(data)}`}
                className={styles.description}
              >
                {getGroupVK(data)}
              </a>
            </div>
            <div className={styles.contact}>
              <div className={styles.title}>Чат в MAX:</div>
               {getMaxIcon(data)}
            </div>
          </div>
        </div>
      </div>
      {data.ProfileClasses && String(data.ProfileClasses).trim() ? (
        <div className={`container ${styles.second}`}>
          <div className={styles.tags}>
            <div className={styles.title}>Профильные классы</div>
            <div className={styles.profileClassesText}>
              {data.ProfileClasses}
            </div>
          </div>
        </div>
      ) : null}
      <div className={`container ${styles.second}`}>
        <div className={styles.contacts}>
          <div className={styles.contact}></div>
          {person.fio ? (
            <div className={styles.contact}>
              <CardArrow
                sizeArrow={{ width: 33, height: 33 }}
                customStyles={{
                  main: styles.card,
                  border: styles.border,
                  arrow: styles.arrow,
                }}
                rotate="rightTop"
              >
                <div className={styles.inner}>
                  <div className={styles.title}>Контактное лицо</div>
                  <div className={styles.about}>
                    <img className={styles.photo} src={noPhoto} alt="Фото" />
                    <div className={styles.contacts}>
                      <div className={styles.name}>{person.fio}</div>
                      <div className={styles.positions}>
                        <div className={styles.title}>Должность:</div>
                        {person.positions.map((item) => (
                          <div key={item.Id} className={styles.position}>
                            {item.Value}
                          </div>
                        ))}
                      </div>
                      <div className={styles.links}>
                        <div className={styles.phones}>
                          <div className={styles.title}>Телефон:</div>
                          {person.phones.map((item) => (
                            <div key={item.Id} className={styles.phone}>
                              {item.Value}
                            </div>
                          ))}
                        </div>
                        <div className={styles.emails}>
                          <div className={styles.title}>Почта:</div>
                          {person.emails.map((item) => (
                            <div key={item.Id} className={styles.email}>
                              {item.Value}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardArrow>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default About;
